import React from "react";
import { TContactForm } from "@/features/clients/create/types";
import { TextField } from "mui-rff";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const ContactForm = ({ required }: TContactForm): any => {
    const { t } = useTranslation();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_webpage')}
                    name="customers_pagina_web"
                    required={required.customers_pagina_web}
                />
            </Grid>
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_phone')}
                    name="customers_telefono"
                    required={required.customers_telefono}
                />
            </Grid>
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_fax_number')}
                    name="customers_fax"
                    required={required.customers_fax}
                />
            </Grid>
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_aux_email_1')}
                    name="customers_email_2"
                    required={required.customers_email_2}
                />
            </Grid>
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_aux_email_2')}
                    name="customers_email_3"
                    required={required.customers_email_3}
                />
            </Grid>

        </Grid>
    );
}

export default ContactForm;
